// CombinedProviders.tsx
import React from 'react'
import { LoadingProvider } from './context/LoadingContext'
import ThemeProvider from './theme/ThemeProvider'
import { ToastProvider } from './context/ToastContext'

const CombinedProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider>
      <ToastProvider>
        <LoadingProvider>{children}</LoadingProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}

export default CombinedProviders
